// extracted by mini-css-extract-plugin
export default {"mediaMd":"(min-width: 736px) and (max-width: 1311.98px)","mediaLg":"(min-width: 1312px)","mainFrame":"templates_mainFrame__QYwdU"};